// src/utils/mediaConversion/timing.ts

export function parseIso(iso?: string | null): number | null {
  if (!iso) return null;
  const t = Date.parse(iso);
  return Number.isFinite(t) ? t : null;
}

export function isHeartbeatStale(
  heartbeatAtIso?: string | null,
  updatedAtIso?: string | null,
  nowMs?: number,
  staleAfterMs: number = 45_000
): boolean {
  const hb = parseIso(heartbeatAtIso);
  const up = parseIso(updatedAtIso);

  // Prefer heartbeat; fallback to updated_at
  const ref = hb ?? up;
  if (!ref) return false;

  const now = typeof nowMs === "number" ? nowMs : Date.now();
  return now - ref > staleAfterMs;
}
